import React from 'react';
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import headerLogo from "../medias/header-logo.png";
import MoblieHeader from './MoblieHeader';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > lastScrollTop);
            lastScrollTop = scrollTop;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <motion.div
            style={{boxShadow: isScrolled ? '0px 2px 5px rgba(0, 0, 0, 0.2)' : 'none'}}
            className={`sticky top-0 left-0 right-0 z-50 bg-[#3B79B3] h-[66px]`}
        >
            <div className="flex justify-between items-center max-w-[1120px] mx-auto pt-[12px] px-[24px]">
                <a href='#'><img className='cursor-pointer' src={headerLogo} alt="" style={{height: '40px'}}/></a>
                <div className='sm:flex items-center gap-[24px] text-white hidden'>
                    <a href="#features"><p className='text-[14px] font-semibold cursor-pointer header-link'>Features</p></a>
                    <a href="#pricing"><p className='text-[14px] font-semibold cursor-pointer header-link'>Pricing</p></a>
                    <a href="https://customsync.app/login?signup=true"><p className='text-[14px] font-semibold cursor-pointer header-link'>Sign up</p></a>
                    <a href="https://customsync.app/login">
                        <div className="cursor-pointer text-white text-nowrap bg-[#F29E13] max-w-[175px] px-[16px] py-[8px] rounded-lg font-bold orange-button">
                            Login
                        </div>
                    </a>
                </div>
                <div className='sm:hidden block'>
                    <MoblieHeader />
                </div>
            </div>
        </motion.div>
    );
};

export default Header;